<template>
  <el-scrollbar v-if="componentShow" class="scroll-container" ref="scrollContainer" @wheel.native.prevent="handleScroll">
    <div class="scroll-wrapper" ref="scrollWrapper" :style="{left: left+'px'}">
      <slot></slot>
    </div>
  </el-scrollbar>
</template>
<script>
  const tagAndTagSpacing = 0 // tag间距
  export default {
    name: 'scrollPane',
    data() {
      return {
        left: 0,
          componentShow:true
      }
    },
    methods: {
      handleScroll(e) {
        const eventDelta = e.wheelDelta || -e.deltaY * 3
        const $scrollWrapper = this.$refs.scrollContainer.$refs.wrap
        $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft+eventDelta/4;
      },
      moveToTarget(currentTag) {
        const $container = this.$refs.scrollContainer.$el;
        const $containerWidth = $container.offsetWidth
        const $scrollWrapper = this.$refs.scrollContainer.$refs.wrap;
        const tagList = this.$parent.$refs.tag

        let firstTag = null
        let lastTag = null

        if (tagList.length > 0) {
          firstTag = tagList[0]
          lastTag = tagList[tagList.length - 1]
        }

        if (firstTag === currentTag) {
          $scrollWrapper.scrollLeft = 0
        } else if (lastTag === currentTag) {
          $scrollWrapper.scrollLeft = $scrollWrapper.scrollWidth - $containerWidth
        } else {
          const currentIndex = tagList.findIndex(item => item === currentTag)
          const prevTag = tagList[currentIndex - 1];
          const nextTag = tagList[currentIndex + 1];

          const afterNextTagOffsetLeft = nextTag.$el.offsetLeft + nextTag.$el.offsetWidth + tagAndTagSpacing

          const beforePrevTagOffsetLeft = prevTag.$el.offsetLeft - tagAndTagSpacing

          if (afterNextTagOffsetLeft > $scrollWrapper.scrollLeft + $containerWidth) {
            $scrollWrapper.scrollLeft = afterNextTagOffsetLeft - $containerWidth
          } else if (beforePrevTagOffsetLeft < $scrollWrapper.scrollLeft) {
            $scrollWrapper.scrollLeft = beforePrevTagOffsetLeft
          }
        }
      }
    },
      beforeDestroy(){
        this.componentShow = false;
      }
  }
</script>
<style scoped>
  .scroll-container {
    white-space: nowrap;
    position: relative;
    overflow: hidden;
    width: 100%;
  }
  .scroll-container >>> .el-scrollbar__bar{
    bottom: 0;
  }
  .scroll-container >>> .el-scrollbar__wrap {
    height: 52px;
  }
  .scroll-container >>> .el-scrollbar__bar.is-horizontal {
    height: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/scrollPane/index.vue